// API Reference: https://www.wix.com/velo/reference/api-overview/introduction
// “Hello, World!” Example: https://learn-code.wix.com/en/article/1-hello-world
import wixWindow from 'wix-window';

$w.onReady(function () {
// Write your JavaScript here$w.onReady(function () {
$w("#maplightColored").hide();
if(wixWindow.formFactor === "Desktop"){
  $w("#vectorImage17").hide();
  $w("#vectorImage18").hide();
  // code that will only run on mobile
}
if(wixWindow.formFactor === "Mobile"){
  $w("#vectorImage17").hide();
  // code that will only run on mobile
}
$w("#horizontalMenu2").hide();
	// To select an element by ID use: $w("#elementID")

	// Click "Preview" to run your code
});